<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to=" __('actions.back_thing', {thing: __('general.overview')})" :href="$route('brands.product-import.overview')"/>

        </Toolbar>
        <Card>
            <errors :errors="errors" show-close/>

            <div class="row no-gutters">
                <div class="col">
                    <div class="card card-body">
                        <h3>Weisen Sie die Felder aus Ihrer Datei zu</h3>

                        <h4 class="mt-5"><i class="fas fa-info-circle mr-2"/>Mit Marke(n) verknüpfen</h4>
                        <div class="row pb-3">
                            <div class="col-xl-6">
                                <label class="font-weight-bold">Marke(n)</label>
                                <select-multi-or-single v-model="multi"/>
                                <span class="form-text text-muted">Wählen Sie aus, ob Ihre Datenquelle Produkte zu einer oder mehreren Marke(n) bereitstellen.</span>
                            </div>
                            <div class="col-xl-6">
                                <div v-if="!multi">
                                    <label class="font-weight-bold">Marke</label>
                                    <select class="form-control" v-model="mapping.brand_uuid">
                                        <option value="" selected disabled>Bitte auswählen</option>
                                        <option v-for="brand in userBrands" :value="brand.uuid">{{ brand.name }}</option>
                                    </select>
                                    <span class="form-text text-muted">Wählen Sie die Marke aus, für die Sie Produktdaten importieren möchten.</span>
                                </div>
                                <FormGroupNew v-else label="Feld mit Markennamen" required>
                                    <VueMultiselect :options="feedColumns" v-model="mapping.brand_name"
                                                     placeholder="Bitte auswählen" :allow-empty="false"/>
                                    <span class="form-text text-muted">Wählen Sie die Spalte aus, in der sich der Name der Marke befindet.</span>
                                </FormGroupNew>
                            </div>
                        </div>

                        <hr>
                        <h4 class="pt-3"><i class="fas fa-images mr-2"/>Basisdaten</h4>
                        <p>
                            Wählen Sie mit Hilfe der Dropdowns die passenden Spalten aus Ihrer Datei aus. Basisdaten
                            enthalten die grundlegenden Eigenschaften ihrer Artikel und werden benötigt um diese in
                            youbuyda
                            anzuzeigen.
                        </p>
                        <div class="row">
                            <div class="col-xl-6">
                                <FormGroupNew label="Produktgruppe">
                                    <VueMultiselect :options="feedColumns" v-model="mapping.product_group"
                                                     placeholder="Bitte auswählen" :allow-empty="false"/>
                                    <span class="form-text text-muted">Produktgruppen vereinfachen es mehrere Ausführungen (Artikel) eines Produkts zusammenzufassen. Geben Sie den Spaltennamen an, welche die Produktgruppe enthält.</span>
                                </FormGroupNew>
                            </div>
                            <div class="col-xl-6 col-auto"/>
                            <div class="col-xl-6">
                                <FormGroupNew label="EAN/GTIN" required>
                                    <VueMultiselect :options="feedColumns" v-model="mapping.ean"
                                                     placeholder="Bitte auswählen" :allow-empty="false"/>
                                    <span class="form-text text-muted">Wählen Sie die Spalte aus, in der sich die EAN befindet.</span>
                                </FormGroupNew>
                            </div>
                            <div class="col-xl-6">
                                <FormGroupNew label="Artikel-Nr. (SKU)">
                                    <VueMultiselect :options="feedColumns" v-model="mapping.sku"
                                                     placeholder="Bitte auswählen"/>
                                    <span class="form-text text-muted">Falls vorhanden, wählen Sie die Spalte aus, welche Ihre Artikelnummer enthält.</span>
                                </FormGroupNew>
                            </div>
                            <div class="col-xl-6">
                                <FormGroupNew label="Name des Artikels" required>
                                    <VueMultiselect :options="feedColumns" v-model="mapping.title"
                                                     placeholder="Bitte auswählen" :allow-empty="false"/>
                                    <span class="form-text text-muted">Wählen Sie die Spalte aus die den Artikelnamen enthält.</span>
                                </FormGroupNew>
                            </div>
                            <div class="col-xl-6">
                                <FormGroupNew label="Beschreibung des Artikels" required>
                                    <VueMultiselect :options="feedColumns" v-model="mapping.description"
                                                     placeholder="Bitte auswählen" :allow-empty="false"/>
                                    <span class="form-text text-muted">Wählen Sie die Spalte aus welche die Beschreibung zu Ihrem Artikel enthält.</span>
                                </FormGroupNew>
                            </div>
                        </div>

                        <hr>
                        <h4 class="pt-3"><i class="fas fa-images mr-2"/>Bilder</h4>
                        <p>Es wird mindestens ein Bild benötigt um einen Artikel importieren zu können.</p>
                        <div class="pb-1">
                            <FormGroupNew label="Bild-URLs" required>
                                <div class="row no-gutters" v-for="(url, i) in mapping.images">
                                    <div class="col-xl-8 col-11">
                                        <VueMultiselect :options="feedColumns" v-model="mapping.images[i]"
                                                         placeholder="Bitte auswählen" :allow-empty="false"/>
                                    </div>
                                    <div class="col-1 pl-3">
                                        <button class="btn btn-default btn-hover-danger"
                                                @click="removeImage(i)">
                                            <i class="fas fa-trash mr-n1"/>
                                        </button>
                                    </div>
                                </div>
                                <span class="form-text text-muted">Wählen Sie die Spalte aus welche die URL zu dem Bild ihres Artikels enthält. Es können beliebig viele Bild-URLs angegeben werden.</span>
                                <button class="btn btn-sm btn-light-primary mt-3" @click="addImage">
                                    <i class="fas fa-plus mr-1"/>weiteres Bild zuweisen
                                </button>
                            </FormGroupNew>
                        </div>

                        <hr>
                        <h4 class="pt-3"><i class="fas fa-list-ul mr-2"/>Attribute</h4>
                        <p>Attribute sind zusätzliche Eigenschaften die Ihre Artikel haben können. Attribute sind zum
                            Beispiel: die Farbe, Größe oder Zielgruppe.</p>
                        <div class="pb-3">
                            <div class="d-flex flex-row pb-2" v-for="(attribute, i) in mapping.attributes">
                                <div class="flex-grow-1" style="width: 22%;">
                                    <VueMultiselect v-model="mapping.attributes[i].attribute"
                                                     :options="attributes"
                                                     label="name"
                                                     track-by="id"
                                                     :allow-empty="false"
                                    >
                                        <template slot="singleLabel" slot-scope="props">
                                                <span class="option__desc"><span
                                                    class="option__title">Attribut: <b>{{ props.option.name }}</b></span></span>
                                        </template>
                                    </VueMultiselect>
                                </div>
                                <div class="d-flex flex-column justify-content-center p-3">
                                    <i class="fas fa-arrow-circle-right text-primary text-xl"/>
                                </div>
                                <div class="flex-grow-1">
                                    <VueMultiselect :options="feedColumns" v-model="mapping.attributes[i].column"
                                                     placeholder="Bitte auswählen" :allow-empty="false"/>
                                </div>
                                <div class="pl-3">
                                    <button class="btn btn-default btn-hover-danger" @click="removeAttribute(i)">
                                        <i class="fas fa-trash mr-n1"/>
                                    </button>
                                </div>
                            </div>
                            <span class="form-text text-muted">
                                    Wählen Sie links ein Attribut und rechts den Feldnamen in Ihrer Datei, aus dem die Information gelesen wird. Ein benötigtes Attribut ist nicht vorhanden?
                                    <a href="#" @click.prevent="createAttribute">Neues Attribut erstellen</a>
                                </span>
                            <button class="btn btn-sm btn-light-primary mt-3"
                                    :disabled="lastAttributeUnmapped"
                                    @click="addAttribute">
                                <i class="fas fa-plus mr-1"/>
                                <span v-show="mapping.attributes && mapping.attributes.length">weiteres </span>Attribut
                                zuweisen
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 pl-xl-3">
                    <div class="card card-body">
                        <mapping-preview :mapping="mapping"
                                         :row="feedFirstRow"
                                         :attributes="attributes || []"
                                         :brand="brandName"/>
                    </div>

                    <button v-if="!startButtonHidden" class="mt-3 btn btn-block btn-success" @click="submitMapping">
                        <span><i class="fas fa-save mr-1"/>Speichern</span>
                    </button>

                    <a v-if="mappingSaved" :href="$route('brands.product-import.start', {sourceId: sourceId})" class="mt-3 btn btn-block btn-info">
                        Import starten<i class="fas fa-arrow-circle-right ml-2"/>
                    </a>
                </div>
            </div>
        </Card>

    </div>
</template>

<script>
import MappingPreview from '@components/Brand/ProductImport/MappingPreview'
import VueMultiselect from 'vue-multiselect'
import CsrfToken from '@components/CsrfToken'
import Errors from '@components/Errors'
import BrandProductImportStats from '@components/Brand/ProductImport/BrandProductImportStats'
import SelectMultiOrSingle from '@components/Brand/ProductImport/Setup/SelectMultiOrSingle'
import Card from '@components/Cards/Card.vue'
import Toolbar from '@components/Toolbar.vue'
import BackButton from '@components/BackButton.vue'
import FormGroupNew from '@components/Form/FormGroupNew.vue'
import {rewriteUrlNew} from '@composables/rewriteUrlNew'

export default {
    components: {
        FormGroupNew,
        BackButton, Toolbar,
        Card,
        MappingPreview,
        VueMultiselect,
        CsrfToken,
        Errors,
        BrandProductImportStats,
        SelectMultiOrSingle,
    },

    props: {
        firebaseUid: String,
        sourceId: Number,
        attributes: Array,
        userBrands: Array,
        multiInit: Boolean,
        feedColumns: Array,
        feedFirstRow: Object,
        mappingInit: {
            type: Object,
            default: () => {
                return {
                    product_group: '',
                    ean: '',
                    title: '',
                    description: '',
                    sku: '',
                    brand_name: '',
                    brand_uuid: '',
                    images: [],
                    attributes: [],
                }
            },
        },
    },

    data() {
        return {
            startButtonHidden: false,
            loading: false,
            multi: false,
            mappingSaved: false,
            mapping: {},
            errors: {},
            productImportMapping: this.$inertia.form({
                multi: this.multi,
                mapping: {},
            })
        }
    },

    mounted() {
        this.multi = this.multiInit
        this.mapping = this.mappingInit

        if (this.mappingInit.ean !== '') {
            this.mappingSaved = true
        }
    },

    methods: {
        addAttribute() {
            this.mapping.attributes.push({attribute: {id: -1, slug: '', name: ''}, column: ''})
        },

        addImage() {
            this.mapping.images.push('')
        },

        removeAttribute(n) {
            let filtered = []
            for (let i = 0; i < this.mapping.attributes.length; i++) {
                if (i !== n) {
                    filtered.push(this.mapping.attributes[i])
                }
            }
            this.mapping.attributes = filtered
        },

        removeImage(n) {
            let filtered = []
            for (let i = 0; i < this.mapping.images.length; i++) {
                if (i !== n) {
                    filtered.push(this.mapping.images[i])
                }
            }
            this.mapping.images = filtered
        },

        submitMapping() {
            let mapping = {}

            for (let key in this.mapping) {
                let value = this.mapping[key]
                if (value !== null && value !== undefined) {
                    mapping[key] = value
                }
            }

            for (let i in this.mapping.attributes) {
                let attribute = this.mapping.attributes[i].attribute
                mapping.attributes[i].id = attribute.id
                mapping.attributes[i].name = attribute.name
            }

            this.errors = {}
            this.loading = true

            this.productImportMapping.transform(
                (data) => ({
                    ...data,
                    mapping: mapping
                })
            ).post(this.$route('brands.product-import.mapping.post', {sourceId: this.sourceId}), {
                onSuccess: () => {
                    this.mappingSaved = true;
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false
                }
            });
        },

        async createAttribute() {
            const {value: name} = await Swal.fire({
                title: 'Neues Attribut erstellen',
                input: 'text',
                inputLabel: 'Geben Sie dem Attribut einen Namen',
                inputValue: '',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Sie müssen einen Namen angeben!'
                    }
                },
            })

            let slug = name.replaceAll(' ', '-').replace(/[^a-z\d-]/i, '').toLowerCase()
            let index = this.attributes.length

            this.attributes.push({
                id: index * -1,
                slug: slug,
                name: name,
            })
        },
    },

    computed: {
        lastAttributeUnmapped() {
            if (this.mapping.attributes === undefined) {
                return false
            }

            let i = this.mapping.attributes.length - 1
            let attribute = this.mapping.attributes[i]

            if (!attribute) {
                return false
            }

            return attribute.attribute.name.length === 0 || attribute.column.length === 0
        },

        brandName() {
            if (this.multi) {
                return this.feedFirstRow[this.mapping.brand_name]
            }

            for (let brand of this.userBrands) {
                if (brand.uuid === this.mapping.brand_uuid) {
                    return brand.name
                }
            }
        },
    },

    watch: {
        mapping: {
            handler() {
                rewriteUrlNew('mapping', this.mapping)
            },
            deep: true,
        },
        multi() {
            rewriteUrlNew('multi', this.multi)
        },
    },
}
</script>
